import React from 'react';
import { useFormContext } from 'react-hook-form';
import CleanTextInput from '../../components/TextInput/TextInput';

const TextInput: React.FC<any> = ({ name, state, ...props }) => {
  const { register } = useFormContext<any>();

  return <CleanTextInput {...register(name)} state={state} {...props} />;
};

export default TextInput;
